import { PropertyCard } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';

const skeletonSection = css({
  flex: 1,
  paddingInline: { base: 'default', md: 0 },
  paddingBottom: { base: 'default', md: 0 },
  paddingTop: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
});

const skeletonGrid = css({
  display: 'grid',
  gridTemplateColumns: '1fr',
  // Mirror LiveListingsGrid's container-query threshold so the skeleton's
  // column count matches the rendered grid at every panel width.
  '@container srpContentPanel (min-width: 36em)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  gap: '400',
  marginBottom: '400',
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

// Two cards: one row where the panel is wide enough for two columns, two rows where
// it is not. Both fit inside the height the empty-results region reserves, so the
// skeleton no longer resizes that region — six cards overflowed it at every width,
// moving the breadcrumbs and area content on each live search (HP-8727).
const SKELETON_CARD_COUNT = 2;

type ListingsSkeletonProps = {
  ariaLabel: string;
};

export function ListingsSkeleton({ ariaLabel }: ListingsSkeletonProps) {
  return (
    <div
      id="srp-listings-skeleton"
      data-srp-component="listings-skeleton"
      className={skeletonSection}
      aria-busy="true"
      aria-live="polite"
    >
      <ul role="list" aria-label={ariaLabel} className={skeletonGrid}>
        {Array.from({ length: SKELETON_CARD_COUNT }).map((_, i) => (
          <li key={i} aria-hidden="true">
            <PropertyCard appearance="large" loading />
          </li>
        ))}
      </ul>
    </div>
  );
}
